<template lang="html">
  <div id="home-page">

    <!-- Banners -->
    <section class="banner-section">
      <swiper class="swiper d-none d-lg-block" :options="bannersOptions">
        <swiper-slide v-for="(bd, bdInx) in banners.desktop" :key="'bdInx-'+bdInx">
          <a :href="bd.url">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner.png" v-bind:style="{ backgroundImage: 'url('+bd.image+')' }">
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <swiper class="swiper d-lg-none" :options="bannersOptions">
        <swiper-slide v-for="(bm, bmInx) in banners.mobile" :key="'bmInx-'+bmInx">
          <a :href="bm.url">
            <img class="placed-backg d-lg-block" src="public/images/pages/home/banner-m.png" v-bind:style="{ backgroundImage: 'url('+bm.image+')' }">
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <!--  -->

    <!-- Searchbar -->
    <SearchbarComponent></SearchbarComponent>
    <!--  -->

    <section class="services-section-st1">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">SERVICIOS</h2>
          </div>

          <div class="col-lg-4 col-service">
            <router-link class="t-250 box" to="/servicios/macetas-de-plastico-para-cultivo">
              <div class="t-250 inside">
                <div class="b-image">
                  <img src="public/images/pages/services/icon-1.png">
                </div>

                <div class="b-text">
                  <h5>Maceta para cultivo</h5>

                  <p>
                    Macetas para vivero, para la industria agrícola y floricultura.
                  </p>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-service">
            <router-link class="t-250 box" to="/servicios/macetas-de-plastico-decorativas">
              <div class="t-250 inside">
                <div class="b-image">
                  <img src="public/images/pages/services/icon-2.png">
                </div>

                <div class="b-text">
                  <h5>Macetas decorativas</h5>

                  <p>
                    Macetas decorativas para el hogar, la oficina y el jardin.
                  </p>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-service">
            <router-link class="t-250 box" to="/servicios">
              <div class="t-250 inside">
                <div class="b-image">
                  <img src="public/images/pages/services/icon-3.png">
                </div>

                <div class="b-text">
                  <h5>Servicios para la industria</h5>

                  <p>
                    Fabrica, maquila y diseño de piezas en plastico.
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="products-section">
      <div class="container med-container" v-if="products.length">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">PRODUCTOS DESTACADOS</h2>
          </div>

          <div class="col-12 col-products">
            <swiper class="swiper carousel-t1" :options="productsOption">
              <swiper-slide v-for="(p, pInx) in products" :key="'pInx-'+pInx">
                <div class="col-12 px-0 box-product-s1">
                  <router-link class="box-link" :to="'/producto/'+$root._converToURL(p.name, p.id)">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+p.image+')' }">
                      <img src="public/images/shared/empty.png">
                    </div>

                    <div class="box-info">
                      <h5 class="title">{{ p.name }}</h5>

                      <!-- <h5 class="price">DESDE ${{ p.price }}</h5> -->
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <!-- Blog -->
    <section class="blog-section">
      <div class="container med-container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">BLOG</h2>
          </div>

          <div class="col-12">
            <swiper class="swiper swiper-st-2" :options="blogOptions">
              <swiper-slide v-for="(ah, ahInx) in blog" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 box-article-s1">
                  <router-link class="box" :to="'/blog/'+$root._converToURL(ah.name, ah.id)">
                    <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ah.image+')' }"></div>

                    <div class="box-info">
                      <h5 class="title">{{ ah.name }}</h5>

                      <div class="b-text" v-html="ah.short_description"></div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

  </div>
</template>

<script>
import SearchbarComponent from './shared/searchbar-component.vue';
export default {
  components: {
    SearchbarComponent
  },

  data() {
    return {
      banners: {
        desktop: [
          // { image: 'public/images/pages/home/banner-1.jpg' },
        ],
        mobile: [
          // { image: 'public/images/pages/home/banner-1-m.jpg' },
        ],
      },

      products: [
        // { image: 'public/images/pages/products/product-2.jpg', price: '119', title: 'Maceta de muestra tipo 2' },
      ],

      blog: [
        // { image: 'public/images/pages/blog/article-1.jpg',
        //   title: 'Los mejores diseños de macetas para adornar tu casa y darle un toque especial.',
        //   short_description: `
        //     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        //   `
        // },
      ],

      // == Carousel options ==
      bannersOptions: {
        loop: true,
        speed: 700,
        effect: 'fade',

        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      productsOption: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 15,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          992: {
            spaceBetween: 15,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },

      blogOptions: {
        slidesPerView: 2,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        }
      },
      // == ==
    }
  },

  methods: {
    getHome() {
      axios.get(tools.url('/api/home')).then((response) =>{
        this.banners = response.data.banners;
        this.products = response.data.products;
        this.blog = response.data.blog;
        // this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.getHome();
  },
}
</script>
